<app-sub-page class="width-100" navBackRoute="/settings">
    <div class="flex width-100 column flex-1 flex-between" style="max-width: 800px">
      <div class="flex width-100 column flex-1 gap-05">
        <div
          class="flex width-100 flex-between align-center rounded-sm"
          style="background-color: var(--surface-50); padding: 0.5rem"
        >
          <div class="text-title">VMAX Default</div>
          @if (settings$ | async; as settings) { @if (settings.isLoading && !settings.response) {
          <p-skeleton width="80%" height="100%" />
          } @else {
          <input [value]="settings.response?.vMaxDefault" type="text" (keydown)="onKeyDown($event)" inputmode="numeric" />
          } }
        </div>
        <div style="font-size: 0.9rem; color: var(--text-color-secondary); padding: 0 1rem">
          The VMAX Default is the default value used when creating a new standby
        </div>
      </div>
      <app-button
        label="Save"
        [outlined]="globalService.theme() === 'dark'"
        [disabled]="!hasChanges"
        (click)="saveSettings()"
      />
    </div>
  </app-sub-page>
  